class AEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const week = ["日", "月", "火", "水", "木", "金", "土"];
    const today = new Date();
    // 月末だとずれる可能性があるため、1日固定で取得
    var showDate = new Date(today.getFullYear(), today.getMonth(), 1);
    
    // 初期表示
    $('.calendar').each(function() {
      showProcess(today, this);
    });

    // 前の月表示
    $('.prev').on('click', function() {
      showDate.setMonth(showDate.getMonth() - 1);
      showProcess(showDate);
    })
    
    // 次の月表示
    $('.next').on('click', function() {
      showDate.setMonth(showDate.getMonth() + 1);
      showProcess(showDate);
    })
    
    // カレンダー表示
    function showProcess(date) {
      var year = date.getFullYear();
      var month = date.getMonth();
      $('.js-year').html(year);
      $('.js-month').html(month + 1);
    
      var calendar = createProcess(year, month);
      $('.calendar').html(calendar);

      $('.js-calendar-date').on('click', function() {
        $('.js-calendar-date').removeClass('is-active');
        $(this).addClass('is-active');
        $('.js-date').text($(this).text());
        $('.js-date-text').css({'display': 'inline'});
        sort_ajax();
      })
    }
    
    // カレンダー作成
    function createProcess(year, month) {
      // 曜日
      var calendar = "<table><tr class='dayOfWeek'>";
      for (var i = 0; i < week.length; i++) {
        calendar += "<th>" + week[i] + "</th>";
      }
      calendar += "</tr>";
    
      var count = 0;
      var startDayOfWeek = new Date(year, month, 1).getDay();
      var endDate = new Date(year, month + 1, 0).getDate();
      var lastMonthEndDate = new Date(year, month, 0).getDate();
      var row = Math.ceil((startDayOfWeek + endDate) / week.length);
    
      // 1行ずつ設定
      for (var i = 0; i < row; i++) {
        calendar += "<tr>";
        // 1colum単位で設定
        for (var j = 0; j < week.length; j++) {
          if (i == 0 && j < startDayOfWeek) {
            // 1行目で1日まで先月の日付を設定
            calendar += "<td class='disabled'>" + (lastMonthEndDate - startDayOfWeek + j + 1) + "</td>";
          } else if (count >= endDate) {
            // 最終行で最終日以降、翌月の日付を設定
            count++;
            calendar += "<td class='disabled'>" + (count - endDate) + "</td>";
          } else {
            // 当月の日付を曜日に照らし合わせて設定
            count++;
            if(year == today.getFullYear()
               && month == (today.getMonth())
               && count == today.getDate()){
              calendar += "<td class='today js-calendar-date'>" + count + "</td>";
            } else {
              calendar += "<td class='js-calendar-date'>" + count + "</td>";
            }
          }
        }
        calendar += "</tr>";
      }
      return calendar;
    }

    // ----------------------------
    // SP カレンダーモーダル
    // ----------------------------

    $('.js-modal, .js-close').on('click', function() {
      $('.is-modal').toggleClass('is-active');
      $('body').toggleClass('no-scroll');
    })

    // ----------------------------
    // ajaxで日付ソート
    // ----------------------------

    // let add_post_target = $('.x__ajax-add-post-target');

    // let load_btn = $('.load_btn');
    // let all_posts = load_btn.data("all-posts"); //カスタム投稿の全件数
    // let this_posts_num = load_btn.data("this-posts-num");
    // let add_posts_num = load_btn.data("add-posts-num");

    // load_btn.on("click", function () {
    //   //読み込み中はボタン非表示
    //   load_btn.addClass('is__hidden');

    //   //ajax処理。data{}のactionに指定した関数を実行、完了後はdoneに入る
    //   $.ajax({
    //     type: 'POST',
    //     url: ajaxurl,
    //     data: {
    //       'action': 'load_post_list_ajax', //functions.phpで設定する関数名
    //       'all_posts': all_posts,
    //       'this_posts_num': this_posts_num,
    //       'add_posts_num': add_posts_num,
    //     },
    //   })
    //   .done(function (data) { //my_ajax_action関数で取得したデータがdataに入る
    //     console.log(data);
    //     add_post_target.append(data);
    //     setTimeout(function () {
    //       add_post_target.find('.x__add-post').removeClass('is__hidden');
    //     }, 100);
    //     //表示件数を増やす
    //     this_posts_num = this_posts_num + add_posts_num;
    //     load_btn.attr('data-this-posts-num', this_posts_num);

    //     //まだ全件表示されていない場合、ボタンを再度表示
    //     if (all_posts > this_posts_num) {
    //       load_btn.removeClass('is__hidden');
    //     }
    //   })
    //   .fail(function () {
    //     alert('エラーが発生しました');
    //   })
    // });

    $('.js-prevMonth, .js-nextMonth').on("click", function() {
      $('.js-ttl').css({'display': 'block'});
      $('.js-date-text').css({'display': 'none'});
      $('.js-date').text('');
      sort_ajax();
    })


		var searchParams = new URLSearchParams( window.location.search );
		var url = location.href;
		var searchParams = new URL(url).searchParams;

    if(searchParams.get("p-cat")) {
      $('.js-cat').val(searchParams.get("p-cat"));
    }

    $('.js-cat').on("change", function() {
      $('.js-ttl').css({'display': 'block'});
      sort_ajax();
    })

    function sort_ajax(el) {
      $('.js-postList').animate({
        opacity: 0
      }, 100 );;
      let year = $('.js-year').eq(0).text();
      let month = $('.js-month').eq(0).text();
      let date;
      let cat;

      date = $('.js-calendar-date.is-active') ? $('.js-date').eq(0).text() : undefined;

      cat = $('.js-cat').val() ? $('.js-cat').val() : undefined;

      //ajax処理。data{}のactionに指定した関数を実行、完了後はdoneに入る
      $.ajax({
        type: 'POST',
        url: ajaxurl,
        data: {
          'action': 'load_post_sort_ajax', //functions.phpで設定する関数名
          'year': year,
          'month': month,
          'date': date,
          'cat': cat,
        },
      })
      .done(function (data) { //my_ajax_action関数で取得したデータがdataに入る
        if(data.length <= 3) {
          data = '<p>条件に該当するイベントはありません。<br>別の条件で検索してください。</p>';
        }
        $('.js-postList').html(data);
        $('.js-postList').animate({
          opacity: 1
        }, 100 );;
      })
      .fail(function () {
        alert('エラーが発生しました');
      })
    }
  }
}

class VideoEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event() {

    const modalBtn = document.querySelectorAll(".js-modal-btn")
    const modalTarget = document.querySelector(".js-modal-contents")
    const modalVideo = document.querySelectorAll(".js-modal-video")
    const modalClose = document.querySelector(".js-modal-close")

    modalBtn.forEach((ele, i) => {

      ele.addEventListener("click" ,() => {
        
        modalTarget.classList.add("is-open")

        modalVideo.forEach((video, videoNum) => {
          if(i === videoNum){
            video.classList.add("is-open")
            const videoItem = video.querySelector(".c-modal__video")
            videoItem.play();
          }
        })
      })    
    });

    modalClose.addEventListener("click", () => {
      modalTarget.classList.remove("is-open")
      
      modalVideo.forEach(el => {
        el.classList.stop().remove("is-open")
      })
    });
  }
}

// globals
var CFL = {
  UA: {
    raw: function raw() {
      return navigator.userAgent;
    },
    is: function is(_is) {
      var ua = CFL.UA.raw();
      if (_is === 'issp') {
        return CFL.UA.isSp();
      }
    },
    isSp: function isSp() {
      var ua = CFL.UA.raw();
      return ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0;
    },
    isTablet: function() {
      var ua = CFL.UA.raw();
      if(ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      } else if (ua.indexOf('iPad') > -1
         || (ua.indexOf('Macintosh') > -1 && CFL.UA.Device.isTouch() )
         || ua.indexOf('Android') > 0) {
        return true;
      }

      return false;
    },
    isEdge: function() {
      return this.raw().indexOf('Edge') != -1;
    },
    isIE: function() {
      var ua = CFL.UA.raw();
      return this.raw().indexOf('Trident') != -1 ;
    }
  },
  Device: {
    isTouch: function() {
      return 'ontouchend' in document;
    }
  }
};

var APP = {
	bp: {
		mobile: 850
	}
};

var isMobile = function () {
  return (window.matchMedia('(max-width: '+ APP.bp.mobile +'px)').matches)
}

var isPortrait = function() {
  let defaultOrientation = null;
  if('orientation' in window) {
    var o1 = (window.innerWidth < window.innerHeight);
    var o2 = (window.orientation % 180 == 0);
    defaultOrientation = (o1 && o2) || !(o1 || o2);
  }
  if('orientation' in window) {
    // defaultOrientationがtrueの場合、window.orientationが0か180の時は縦
    // defaultOrientationがfalseの場合、window.orientationが-90か90の時は横
    var o = (window.orientation % 180 == 0);
    if((o && defaultOrientation) || !(o || defaultOrientation)) {
      return true;
    } else {
      return false;
    }
  }
}
class ConceptSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const modalSwiper = new Swiper("." + this.el, {
      loop: true,
      speed: 1000,
      spaceBetween: 200,
  
      // Navigation arrows
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },

    });

    const modalBtn = ('.js-concept-modal-btn');
    const modalTarget = ('.js-concept-modal');
    const modalClose = ('.js-concept-modal-close');

    $(modalBtn).on('click',function(){
      let modalNum = $(this).attr('data-modal');
      modalNum++;
      $(modalTarget).fadeIn(500).css('display','flex');
      modalSwiper.update();
      modalSwiper.slideTo(modalNum,0);
    })

    $(modalClose).on('click',function(){
      $(modalTarget).fadeOut(500);
    })
  }
}

class Mwwpform {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const confirmHideElement = '.confirm-hide';
    $(confirmHideElement).hide();
  }
}

class TopEventSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    if(isMobile()){
      const modalSwiper = new Swiper("." + this.el, {
        loop: false,
        speed: 1000,
        spaceBetween: 15,
        slidesPerView: 1.1
      });
    }
  }
}

class TopFacilityListSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    if(isMobile()){
      const modalSwiper = new Swiper("." + this.el, {
        loop: false,
        speed: 1000,
        spaceBetween: 15,
        slidesPerView: 1.2
      });
    }
  }
}

class TopMovieSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    if(isMobile()){
      const modalSwiper = new Swiper("." + this.el, {
        loop: false,
        speed: 1000,
        spaceBetween: 15,
        slidesPerView: 1.3
      });
    }
  }
}

class TopProjectSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    if(!isMobile()){
      const swiper = new Swiper("." + this.el, {
        loop: true,
        slidesPerView: 'auto',
        speed: 1000,
        spaceBetween: 50,
    
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    
        // Pagination
        pagination: {
            el: '.swiper-pagination',
            type: 'fraction',
        },
    });
    }

    // 翻訳した時の分数表示対応
    window.addEventListener("DOMContentLoaded", switch_css);
    function switch_css(){
      console.log('tete');
      // クエリパラメータを取得
      let param = location.search
      let param_map = query_param_to_map(param);
      console.log(param_map)
      
      // クエリパラメータにmodeが無ければ何もしない
      if(!param_map.get("_x_tr_tl")){
        return
      }else{
        console.log('翻訳中です');
      }
      
      // クエリパラメータに応じたcssに切り替える
      // let css_url = param_map.get("mode") + ".css";
      // var linkstyle = document.getElementById('switch_css');
      // linkstyle.href = css_url;
    }
    // クエリパラメータを取得してMAPにする
    function query_param_to_map(param) {
      param = param.replace('?', '');
      let param_splitted = param.split('&');
      let param_map = new Map();
      param_splitted.forEach( val => {
          let splitted_val = val.split('=');
          param_map.set(splitted_val[0], splitted_val[1]);
      });
      return param_map ;
    }
  }
}

// 参考サイト
// https://hacknote.jp/archives/15289/

var cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
//noScroll
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    this.para_ele = document.querySelectorAll("." + this.el);
    this.para_ele.forEach((ele, index)=> {
      if(ele.classList.contains('js-parallax--reverse')) {
        this.translateY = '20px';
      } else {
        this.translateY = '-20px';
      }
      ele.classList.add(this.el + index);
      gsap.to('.' + this.el + index + ' img', {
        translateY: this.translateY,
        scrollTrigger: {
          trigger: '.' + this.el + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          scrub: 3,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class NavMenu {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event() {
    const navBtn = document.querySelector('.nav-btn');
    const navBtnClose = document.querySelector('.nav-btn-close');
    const navBtnSp = document.querySelector('#nav-btn');
    const navMenuArea = document.querySelector('#nav-menuArea');
    const Overlay = document.querySelector('.js-overlay');
    const navTxt = document.querySelector('.nav-ttl');
    // const navTxtPc = document.querySelector('.nav-ttl-pc');
    const body = document.querySelector('body');
    let navLink = document.querySelectorAll('.navLink');

    navBtn.addEventListener('click', () => {

      console.log('et');
      navMenuArea.classList.add('is-open');
      Overlay.classList.add('is-active');
      // navTxtPc.classList.toggle('is-active');
      body.classList.add('is-active');

      // if(navTxtPc.classList.contains('is-active')){
      //   navTxtPc.textContent = 'CLOSE';
      // } else {
      //   navTxtPc.textContent = 'MENU';
      // }

    });
    navBtnClose.addEventListener('click', () => {

      navMenuArea.classList.remove('is-open');
      Overlay.classList.remove('is-active');
      // navTxtPc.classList.toggle('is-active');
      body.classList.remove('is-active');

      // if(navTxtPc.classList.contains('is-active')){
      //   navTxtPc.textContent = 'CLOSE';
      // } else {
      //   navTxtPc.textContent = 'MENU';
      // }

    });

    navBtnSp.addEventListener('click', () => {

      navMenuArea.classList.toggle('is-open')
      Overlay.classList.toggle('is-active')
      navTxt.classList.toggle('is-active')
      body.classList.toggle('is-active')

      if(navTxt.classList.contains('is-active')){
        navTxt.textContent = 'CLOSE';
      } else {
        navTxt.textContent = 'MENU';
      }

    });


    
    Overlay.addEventListener('click', () => {
      
      navMenuArea.classList.remove('is-open');
      Overlay.classList.remove('is-active');
      // navTxt.classList.remove('is-active');
      body.classList.remove('is-active');

    });

    navLink.forEach((link) => {
    
      link.addEventListener('click', () => {
        
        navMenuArea.classList.remove('is-open');
        Overlay.classList.remove('is-active');
        navTxt.classList.remove('is-active');
        body.classList.remove('is-active');
        navTxtPc.textContent = 'MENU';
        navTxt.textContent = 'MENU';
        
      });
    });


    // スクロール時の縮小（PCのみ）
    const headerWrap = '.js-header';
    if(isMobile()){

    }else{
      document.addEventListener("scroll", function() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
        if (scrollTop > 500) {
            $(headerWrap).addClass("is-active");
        } else {
            $(headerWrap).removeClass("is-active");
        }
      });
    }
  }
}

class ScrollTop {
  constructor(el, opt) {
    this.el = el;
    this.event();
  }
  event() {
    $(function () {
      const pageTop = $('#js-pageTop');
      
      pageTop.click( () => {
        $('body, html').animate({
            scrollTop: 0
        }, 600);
        return false;
      });
    });
  }
}

class VideoControl{
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event() {
    const video = '.js-video';
    $(video).on('click', function() {
      var videoElement = $(this).get(0); // jQuery オブジェクトからネイティブの video 要素を取得
      if ($(this).hasClass('is-play')) {
        videoElement.pause(); // ビデオを一時停止
      } else {
        videoElement.play(); // ビデオを再生
      }
      $(this).toggleClass('is-play');
    });

  }
}

class MovieVideoEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event() {

    const modalBtn = document.querySelectorAll(".js-modal-btn")
    const modalTarget = document.querySelector(".js-modal-contents")
    const modalVideo = document.querySelectorAll(".js-modal-video")
    const modalClose = document.querySelector(".js-modal-close")

    modalBtn.forEach((ele, i) => {

      ele.addEventListener("click" ,() => {
        
        modalTarget.classList.add("is-open")

        modalVideo.forEach((video, videoNum) => {
          if(i === videoNum){
            video.classList.add("is-open")
            const videoItem = video.querySelector(".c-modal__video")
            videoItem.play();
          }
        })
      })    
    });

    modalClose.addEventListener("click", () => {
      modalTarget.classList.remove("is-open");

      modalVideo.forEach((el) => {
        el.classList.remove("is-open");
        if (el.getElementsByClassName("c-modal__video").length) {
          const videoItem = el.querySelector(".c-modal__video");
          videoItem.pause();
          videoItem.currentTime = 0; // 再生位置をリセット
        }
      });
    });
  }
}



(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('.js-inview');
  let topProjectSwiper = new TopProjectSwiper('js-top-project-swiper');
  let mwwpform = new Mwwpform('mw_wp_form_confirm');
  // let videoEvent = new VideoEvent('js-topMovie');
  let movieVideoEvent = new MovieVideoEvent('js-modal-btn');
  let conceptSwiper = new ConceptSwiper('js-concept-modal-swiper');
  let topEventSwiper = new TopEventSwiper('js-top-event-swiper');
  let topFacilityListSwiper = new TopFacilityListSwiper('js-top-facility-list-swiper');
  let topMovieSwiper = new TopMovieSwiper('js-top-movie-swiper');
  let navMenu = new NavMenu('js-navMenu');
  let scrollTop = new ScrollTop('.js-scrollTop');
  let aEvent = new AEvent('p-event');
  let videoControl = new VideoControl('js-video');
});

// スマホ・タブレットの向き判定
// $(window).on('orientationchange', ()=>{
//   if(isPortrait()){
//     console.log('isPortrait');
//   } else {
//     console.log('isLandscape');
//   }
// });